<template>
	<div>
		<div style="margin:35px 5px 0px 16.5%">
			<Form inline>
				<FormItem>
					<Input placeholder="姓名/ID/手机号码" v-model="client_message">
					</Input>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="searchCustomer">检索</Button>
				</FormItem>
				<FormItem>
					<Select v-model="selectClient" @on-change="changeSelectClient">
						<Option v-for="item in clientList" :value="item.id">{{ item.label }}:({{item.id}})
						</Option>
					</Select>
				</FormItem>
			</Form>
		</div>
		<table class="ssss">
			<tr>
				<td class="textr">贷款顾问：</td>

				<td class="textl">
					<Select v-model="formItem.add_uid" :disabled="formItem.check_status ==2 && userInfo.role_type != 4">
						<Option v-for="item in userList" :value="item.value" :key="item.value">
							{{item.label}}
						</Option>
					</Select>
				</td>

				<td class="textr">协助人：</td>
				<td class="textl">
					<Select v-model="formItem.help_uid"
						:disabled="formItem.check_status ==2 && userInfo.role_type != 4">
						<Option v-for="item in userList" :value="item.value" :key="item.value">
							{{item.label}}
						</Option>
					</Select>
				</td>
			</tr>
			<tr>
				<td class="textr">客户姓名：</td>
				<td class="textl"><Input v-model="clientStatus.label" disabled style="width: 300px" /></td>
				<td class="textr">客户手机号：</td>
				<td class="textl"><Input v-model="clientStatus.phone" disabled style="width: 300px" /></td>
			</tr>
			<tr>
				<td class="textr">签约日期：</td>
				<td class="textl">
					<DatePicker :value="formItem.loan_at" @on-change="(e) => {formItem.loan_at = e}" type="date"
						placeholder="请选择时间" style="width: 300px"></DatePicker>
				</td>
				<td class="textr">合同号：</td>
				<td class="textl"><Input v-model="formItem.contract_number" style="width: 300px" /></td>
			</tr>
			<tr>
				<td class="textr">费率：</td>
				<td class="textl" style="position:relative;z-index:1;">
					<Input v-model="formItem.rate" style="width: 300px">
					<div slot="append">
						%
					</div>
					</Input>
				</td>
				<td class="textr">诚意金：</td>
				<td class="textl" style="position:relative;z-index:1;">
					<Input v-model="formItem.sincerity_money" style="width: 300px">
					<div slot="append">
						元
					</div>
					</Input>
				</td>
			</tr>
			<tr>
				<!--td class="textr">诚意金状态：</td>
				<td class="textl" style="position:relative;z-index:1;">
				    <Select v-model="formItem.sincerity_status" :transfer=true style="width:300px">
				        <Option v-for="item in sincerity_status_list" :value="item.value" :key="item.value">{{
				            item.label }}
				        </Option>
				    </Select>
				</td-->
				<td class="textr">诚意金收款方式：</td>
				<td class="textl" style="position:relative;z-index:1;">
					<Select v-model="formItem.sincerity_type" :transfer=true style="width:300px">
						<Option v-for="item in sincerity_type_list" :value="item.value" :key="item.value">{{
				            item.label }}
						</Option>
					</Select>
				</td>
			</tr>
			<tr>
				<td class="textr">新增备注：</td>
				<td class="textl" style="position:relative;z-index:1;" colspan="3">
					<Input v-model="formItem.remark" type="textarea" style="width:92%;height:80px;" :rows="4"
						placeholder="请输入该单的备注情况" />
					<!--textarea style="width:92%;height:80px;" id="remark" name="remark"></textarea-->
				</td>
			</tr>
			<tr>
				<td class="textr">添加合同：</td>
				<td class="textl" style="position:relative;" colspan="3">
					<MyUpload :onlyRead="false" ref="upload"></MyUpload>
					<br>
					<div>提示：仅限上传jpg、png、bmp格式的图片文件，文件大小不能大于4M！</div>
				</td>
			</tr>
			<tr>
				<td class="textr">添加视频：</td>
				<td class="textl" style="position:relative;" colspan="3">
					<div class="demo-upload-list" v-for="(item,index) in videoList" :key="index">
						<template v-if="item.status === 'finished'">
							<!--img :src="{item.url"}-->
							<span style="color: #000FFF;cursor: pointer;">{{item.name}}
								<Icon type="logo-youtube" @click.native="handleView(item.url)"></Icon>
							</span>
						</template>
						<template v-else>
							<Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
						</template>
					</div>
					<Upload style="padding-top: 10px;" multiple ref="videoUpload" :on-success="handleSuccess"
						:action="actionUrl">
						<Button icon="ios-cloud-upload-outline">上传视频</Button>
					</Upload>
				</td>
			</tr>
			<tr>
				<td class="textr">是否是拓客：</td>
				<td class="textl">
					<template>
						<i-switch v-model="formItem.is_introduce" />
					</template>
				</td>
			</tr>
			<tr v-if="formItem.is_introduce === true">
				<td class="textr">拓客人姓名：</td>
				<td class="textl"><Input v-model="formItem.introduce_name" style="width: 300px" /></td>
				<td class="textr">拓客人电话：</td>
				<td class="textl"><Input v-model="formItem.introduce_mobile" style="width: 300px" /></td>
			</tr>
			<modal :title="videoName" v-model="visible" fullscreen>
				<video :src="previewPath" v-if="visible" controls="controls" width="100%"></video>
			</modal>
		</table>
		<div class="addsub">
			<Button type="primary" @click="save" style="cursor:pointer;width: 100px;">保存</Button>
		</div>
	</div>
</template>

<script>
	import MyUpload from '../tool/Upload.vue'
	import config from "../../config";
	import {
		getClientRecord,
		searchCustomer
	} from '@/api/client'
	import {
		getLoan,
		saveLoan,
		beforeContract,
		saveContract,
	} from '@/api/task'
	import {
		getUserList,
		getMyClientTips,
		getAnnounce,
		getDepartmentList,
	} from '@/api/user'
	import {
		mapMutations,
		mapActions,
		mapGetters
	} from "vuex";
	import {
		getAllOrganization,
		getAllProduct
	} from "../../api/runSet";

	export default {
		name: "Loan",
		components: {
			MyUpload
		},
		computed: {
			...mapGetters(['token','userInfo']),
		},
		watch: {
			$route() { // 监听路由变化  // 组件第一次进入不会执行
				if (this.$route.name == "addLoan") {
					this.contractId = this.$route.query.contractId
					if (!this.contractId) {
						this.contractId = 0
						this.initForm();

					}
				}
			},
			contractId() {
				this.loadData();
			}
		},
		mounted() {
			this.contractId = this.$route.query.contractId
			this.actionUrl = process.env.VUE_APP_REQUEST_URL_ENV + "/app/api/uploadFile?system="+this.userInfo.system+"&shop_id="+this.userInfo.shop_id,
			this.$refs['upload'].uploadList = [];
			this.videoList = this.$refs.videoUpload.fileList ? this.$refs.videoUpload.fileList : [];
      if (this.contractId !== this.$route.query.contractId) {
        this.loadData();
      }
		},
		data() {
			return {
				actionUrl: '',
				visible: false,
				previewPath: '',
				videoName: '',
				contractId: 0,
				videoList: [],
				client: [],
				organizationList: [],
				productList: [],
				clientList: [],
				selectClient: '',
				client_message: '',
				clientStatus: [],
				defaultSelectClient: '',
				statusList: [{
						value: 1,
						label: '审核中'
					},
					{
						value: 2,
						label: '已批款'
					},
					{
						value: 3,
						label: '银行已拒绝'
					},
					{
						value: 4,
						label: '已收款'
					},
					{
						value: 5,
						label: '违约'
					}
				],
				sincerity_status_list: [{
					value: 0,
					label: '已收',
				}, {
					value: 1,
					label: '已退',
				}, {
					value: 2,
					label: '转创收',
				}, ],
				sincerity_type_list: [{
					value: 1,
					label: '支付宝',
				}, {
					value: 2,
					label: '微信支付',
				}, {
					value: 3,
					label: '现金支付',
				}, {
					value: 4,
					label: '银行卡支付',
				}, {
					value: 5,
					label: '其他',
				}],
				addContractForm: {
					status: '',
					manager: '',
					client_name: '',
					actionUrl: '',

					sincerity_money: '',
					repay_type: '0',
					sincerity_deal_status: 0,
					department: '',
					videoList: [],
					phone: '',
					rate: '',
					remark: ''
				},
				formItem: {
					join_at: '无',
					loan_at: '无',
					manager: '',
					organization_id: 0,
					contract_number: '',
					add_uid: '',
					product_id: 0,
					rate: '',
					repay_type: '',
					get_money: '',
					loans_money: '',
					monthly_payment: '',
					sincerity_money: '',
					periods: '',
					status: '1',
					check_status: '',
					repay_at: '',
					is_join_loan: false,
					not_receive_money: '',
					videoList: [],
					repay_money: '',
					channel_fee: '',
					sincrtity_status: "",
					is_introduce: false,
					introduce_name: '',
					introduce_mobile: '',
					sincerity_status: '',
					sincerity_type: '',
				},
				userList: [],
			}
		},
		methods: {
			...mapMutations([

				'setTagNavList',
				'addTag',
				'setHomeRoute',
				'closeTag'
			]),
			...mapActions([
				'handleLogOut',
			]),
			async loadData() {
				let that = this;
				let data = {
					token: that.token
				};
				let res = await getAllOrganization(that, data);
				if (res.code == 1) {
					that.organizationList = res.data.list;
				}
				res = await getUserList(that, data);
				if (res.code == 1) {
					that.userList = res.data.list;
				}
				if (that.contractId != 0) {
					let res = await getLoan(that, {
						token: that.token,
						id: that.contractId
					});
					if (res.code = 1) {
						that.formItem = res.data.item;
						if (res.data.item.ext_info != "" && res.data.item.ext_info !== undefined) {
							var jsonStr = JSON.parse(res.data.item.ext_info); //将视频和图片的json转为数据
							this.videoList = jsonStr.videoList ? jsonStr.videoList : [];
							that.$refs['upload'].uploadList = jsonStr.imgList;
						}
						that.clientStatus.id = res.data.item.client_id
						that.clientStatus.username = res.data.item.username
						that.clientStatus.label = res.data.item.client_name
						that.clientStatus.phone = res.data.item.phone
						that.clientStatus.department_name = res.data.item.department_name
					}
				}
			},
			async changeOrganization() {
				let that = this;
				let data = {
					token: that.token,
					organization_id: that.formItem.organization_id
				};
				let res = await getAllProduct(that, data);
				if (res.code == 1) {
					that.productList = res.data.list;
				}
			},
			async searchCustomer() {
				let that = this;
				let data = {
					token: that.token,
					client_message: that.client_message
				};
				let res = await searchCustomer(that, data);
				if (res.code == 1) {
					if (res.data.list == "" || res.data.list == null) {
						this.$Message.error('未检索到客户资料');
						return;
					} else {
						that.clientList = res.data.list;
						that.formItem.add_uid = res.data.list[0].add_uid
						this.clientStatus = res.data.list[0]
						this.selectClient = res.data.list[0].id
					}

				}
			},
			//预览视频
			handleView(path, name) {
				this.videoName = name;
				this.previewPath = path;
				this.visible = true;
			},
			//删除视频
			handleRemove(file) {
				const videoList = this.$refs.videoUpload.fileList;
				this.$refs.videoUpload.fileList.splice(fileList.indexOf(file), 1);
			},
			//视频上传成功
			handleSuccess(res, file) {
				file.url = res.data.url
				this.videoList = this.$refs.videoUpload.fileList;
			},
			changeSelectClient(value) {
				let that = this
				let ret = {}
				let length = that.clientList.length;

				that.clientList.forEach(function(row, index) {
					if (row.id == value) {
						that.clientStatus = that.clientList[index]
					}
				})
				if (that.clientStatus == {}) {
					return false;
				}
			},
			initForm() {
				this.formItem = {
					join_at: '无',
					loan_at: '无',
					manager: '',
					organization_id: 0,
					contract_number: '',
					add_uid: '',
					product_id: 0,
					rate: '',
					repay_type: '',
					get_money: '',
					loans_money: '',
					monthly_payment: '',
					sincerity_money: '',
					periods: '',
					status: '1',
					check_status: '',
					repay_at: '',
					is_join_loan: false,
					not_receive_money: '',
					videoList: [],
					repay_money: '',
					channel_fee: '',
					sincrtity_status: "",
					is_introduce: false,
					introduce_name: '',
					introduce_mobile: '',
				};
			},
			test() {
				//this.closeTag(this.$route)
				this.$router.push({
					name: 'loan_management',
					params: {
						'is_refresh': '1'
					}

				})
			},
			save() {
				var that = this;
				if (that.formItem.is_introduce == true) {
					if (that.formItem.introduce_name == "" || that.formItem.introduce_name == null) {
						this.$Message.error('拓客姓名不能为空');
						return;
					}
					if (that.formItem.introduce_mobile == "" || that.formItem.introduce_mobile == null) {
						this.$Message.error('拓客电话不能为空');
						return;
					}
				}
				this.$Modal.confirm({
					title: "确定保存吗",
					onOk: async () => {
						let data = {
							token: that.token,
							data: that.formItem,
							client_id: that.clientStatus.id,
							principal_uid: that.clientStatus.principal_uid
						};
						data.data.imgList = that.$refs['upload'].uploadList;
						data.data.videoList = that.videoList;
						let res = await saveContract(that, data);
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.$emit('reloadData');
						}
					}
				})
			}
		}
	}
</script>
<style scoped lang="less">
	html,
	button,
	input,
	select,
	textarea {
		font-family: "Microsoft YaHei", Arial, sans-serif;
		font-size: 12px
	}

	ul,
	li {
		margin: 0;
		padding: 0
	}

	body {
		background: #fff;
		margin: 0;
		padding: 0;
		width: 100%;
	}

	li {
		list-style: none;
	}

	a {
		text-decoration: none;
	}

	table.ssss {
		border-collapse: collapse;
		padding: 0px;
		margin: 20px auto;
		width: 96%
	}

	table.ssss tr,
	td {
		border: none;
		margin: 0;
		padding: 0px;
	}

	.textr {
		text-align: right;
		width: 13%
	}

	.textl {
		text-align: left;
		width: 25%
	}

	table.ssss td {
		height: 40px;
		margin-top: 10px;
	}

	table.ssss td input {
		height: 25px;
		border: 1px solid #959595;
		width: 80%
	}

	.addsub {
		width: 96%;
		margin: 0 auto;
		text-align: center;
	}

	.addsub input {
		border: 0;
		width: 120px;
		height: 34px;
		color: #fff;
		font-size: 14px;
	}

	.red {
		background: #c7273a
	}

	.blue {
		background: #4761ea;
		margin-left: 138px;
	}

	.absdiv {
		position: absolute;
		width: 29px;
		height: 28px;
		border-left: 1px solid #959595;
		text-align: center;
		line-height: 28px;
		top: 6px;
		right: 19.5%;
	}

	.myselect {
		height: 31px;
		width: 81%;
		border: 1px solid #959595;
	}

	.search_rs {
		background: #eeeeed;
		color: #0044BB;
		min-height: 50px;
		padding: 20px 205px 10px 192px;
		margin-top: 10px;
		line-height: 35px;
	}

	.search_rs a {
		margin-right: 33px;
	}

	.search_rs a:hover {
		border: none;
		position: relative;
		z-index: 2;
	}

	/*解决在IE6的问题*/
	.search_rs a span {
		display: none;
		word-wrap: break-word;
	}

	.search_rs a:hover span {
		z-index: 999;
		display: block;
		width: 300px;
		min-height: 200px;
		position: absolute;
		left: -90px;
		top: 30px;
		background-color: #ffffff;
		border: 1px solid #0044bb;
		padding: 10px;
		color: #000;
	}

	.calendar {
		z-index: 1;
	}

	.search_callkefuid {
		background: #eeeeed;
		color: #0044BB;
		min-height: 50px;
		margin-top: 10px;
		line-height: 35px;
	}

	.search_callkefuid a {
		margin-right: 33px;
	}

	.images {
		width: 100%;
		height: 137px;
		margin-top: 1%;
	}

	.images li {
		width: 100px;
		height: auto;
		line-height: 37px;
		text-align: center;
		margin-left: 2%;
		margin-top: 1%;
		float: left;
		color: #b0b0b0;
		font-size: 12px;
	}

	.addimg {
		width: 98px;
		height: 98px;
		cursor: pointer;
		position: relative;
		border: 1px solid #e5e5e5;
		background:url(<{$cdnsite}>/default/manage/images/upload_bg.jpg) no-repeat;
		background-position: 38px;
	}

	.newaddimg {
		width: 98px;
		height: 98px;
		position: relative;
		border: 1px solid #e5e5e5;
	}

	.sub {
		background: #ee5c6d;
		border: none;
		width: 130px;
		height: 40px;
		color: #fff;
		font-size: 14px;
		margin-left: 2%;
		margin-bottom: 50px;
	}

	.hidefile {
		width: 98px;
		height: 98px;
		border: none;
		opacity: 0;
		position: absolute;
		top: 0;
		left: 0;
		cursor: pointer;
	}

	.hidefile1 {
		width: 98px;
		height: 98px;
		border: none;
		opacity: 0;
		position: absolute;
		top: 0;
		left: 0;
		cursor: pointer;
	}

	#pic {
		height: 100%;
		width: 100%;
	}

	.del_img {
		width: 23px;
		height: 23px;
		position: absolute;
		top: -11px;
		right: -11px;
		display: none
	}
</style>
<style scoped lang="less">
	.icon-bixuan {
		color: red;
	}

	.title_css {
		width: 86px;
		text-align: right;
		margin-right: 10px;
	}

	.list_flex {
		display: flex;
		align-items: center;
		margin: 10px 0;
	}

	.modal_flex {
		display: flex;
		align-items: center;
		margin: 10px 0;

		.item_box {
			width: auto;
			display: flex;
			align-items: center;

			.btn {
				margin: 0 10px;
			}

			.title_box {
				width: 130px;
				text-align: right;
			}
		}

		.icon-bixuan {
			color: #FE485B;
		}
	}
</style>